import { render, staticRenderFns } from "./BaseVideoPlayPage.vue?vue&type=template&id=30623dae&scoped=true"
import script from "./BaseVideoPlayPage.vue?vue&type=script&lang=js"
export * from "./BaseVideoPlayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30623dae",
  null
  
)

export default component.exports